module.exports = __webpack_public_path__ + "img/a_l4.9d22727c.png";